import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import optimistic from './middlewares/optimistic';
import errorhandle from './middlewares/errorhandler';
import rootReducer from './root';

const isProduction = process.env.NODE_ENV === 'production';

let composeFn = null;
if (isProduction) {
    composeFn = compose;
} else {
    const devTools = require('redux-devtools-extension');
    composeFn = devTools.composeWithDevTools;
    //composeFn = compose;
}

const configureStore = preloadedState => {
    const store = createStore(
        rootReducer,
        preloadedState,
        composeFn(applyMiddleware(errorhandle, optimistic, thunk))
    );
    return store;
};

export default configureStore;
